module.exports = __webpack_public_path__ + "img/18_9.10f3b209.png";